var _defs, _circle, _path, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStartTask(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 69.13 78.41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{fill:#fff;}.c{fill:#669;}.d{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:4px;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 34.57,
    cy: 43.84,
    r: 32.57
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M58.48,19c-4-1-3,3-3,3H12.99s2.49-4-3.19-3c-6.32,1,9.83-11.26,9.83-11.26l27.85-1.74,11,13Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 32.48,
    width: 4,
    height: 43,
    rx: 1.42,
    ry: 1.42
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartTask);
export default __webpack_public_path__ + "static/media/startTask.b3e213b88719b6d589903d515e062a42.svg";
export { ForwardRef as ReactComponent };